var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchDropdownChevronOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 12,
    viewBox: "0 0 8 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A1B2BC",
    fillRule: "nonzero",
    stroke: "#A0B2BD",
    strokeWidth: 0.864,
    d: "M6.168 6.103a.32.32 0 0 1-.088.222l-3.604 3.743a.292.292 0 0 1-.294.09.307.307 0 0 1-.216-.226.323.323 0 0 1 .086-.307l3.387-3.543L2.028 2.52a.324.324 0 0 1 .05-.389.29.29 0 0 1 .374-.033l3.624 3.785a.32.32 0 0 1 .092.221z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDropdownChevronOff);
export default __webpack_public_path__ + "static/media/search-dropdown-chevron-off.17e40255574c0d6578a70fb1f4ffef39.svg";
export { ForwardRef as ReactComponent };